<template>
  <div>
    <div v-ripple class="viewer-main" @click="explorer = true">
      <div v-if="value">
        <v-img v-if="!loading" :src="src"></v-img>
        <div v-else class="d-flex flex-column align-center py-5">
          <v-progress-circular color="pink darken-2" class="mb-3" indeterminate :size="75" :width="3" />
          <p class="text-body-2 font-weight-medium mb-0 grey lighten-3 px-10 py-1 rounded">{{loadingText}}</p>
        </div>
      </div>
      <v-card
        elevation="0"
        class="d-flex justify-center align-center px-4 py-6"
        color="grey lighten-3"
        :height="height"
        v-else
      >
        <div>
          <p class="text-center grey--text text--darken-1 mb-0">{{noText}}</p>
        </div>
      </v-card>
    </div>
    <media-explorer
      v-model="explorer"
      @selected="getImage"
      format="images"
      :list-selection="false"
    />
  </div>
</template>

<script>
import MediaExplorer from "./Settings/Media/MediaExplorer.vue";
export default {
  components: { MediaExplorer },
  name: "ThumbnailViewer",
  props: {
    value: {
      required: true
    },
    height: {
      default: "auto"
    },
    noText: {
      required: true,
      type: String,
    },
    loadingText: String,
  },
  data: () => ({
    explorer: false,
    thumbnail: "",
    src: "",
    loading: false,
  }),
  methods: {
    getImage(img) {
      if (img) {
        this.$emit("input", img.name);
      }
    }
  },
  watch: {
    value(img) {
      if (img) {
        this.loading =  true;
        fetch(`${this.$ApiUrl}images/${img.name ? img.name : img}`)
          .then(res => res.blob())
          .then(blob => {
            this.src = URL.createObjectURL(blob);
          }).finally(() => {
          this.loading = false;
        }).catch((err) => {
          this.loading = false;
          console.log(err);
        });
      }
    }
  }
};
</script>

<style>
.viewer-main {
  cursor: pointer;
  user-select: none;
}
</style>